import React from 'react';

import { isFieldForListingType } from '../../util/fieldHelpers';

// Shared components
import ExpandableSection from './ExpandableSection';
import FieldMaybe from './FieldMaybe';

import css from './ListingPage.module.css';

const removeListingIds = ['brand', 'priceDisplayInfo'];

const SectionDetailsMaybe = props => {
  const { publicData, metadata = {}, listingFieldConfig, intl } = props;

  if (!publicData || !listingFieldConfig) {
    return null;
  }

  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);

      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs.filter(config => !removeListingIds.includes(config.key));
  };

  const existingListingFields = listingFieldConfig.reduce(pickListingFields, []);

  return existingListingFields.length > 0 ? (
    <ExpandableSection
      className={css.sectionDetails}
      title={intl.formatMessage({
        id: 'ListingPage.detailsTitle',
      })}
    >
      {existingListingFields.map(detail => (
        <FieldMaybe key={detail.key} heading={detail.label} content={detail.value} />
      ))}
    </ExpandableSection>
  ) : null;
};

export default SectionDetailsMaybe;
